<mat-drawer-container>
  <!-- Loading indicator -->
  <div *ngIf="isLoading" class="flex items-center justify-center h-full w-full min-h-[400px]">
    <mat-spinner diameter="48"></mat-spinner>
  </div>

  <lib-cdw-designation-edit
    #designationEdit
    *ngIf="!isLoading && (currentDesignation || selectedDesignationId === 'new')"
    (deleteDesignation)="onDeleteDesignation()"
    (cancelDesignationEdit)="onCancelEdit()"
    (submitDesignationEdit)="onSubmitEdit($event)"
    (openDetailsDrawer)="onOpenDetailsDrawer($event)"
    [ous]="orgUnitSelectOptions"
    [roles]="roles"
    [userCollections]="userCollections"
    [users]="userSelectOptions"
    [ouCollections]="orgUnitCollections"
    [designation]="currentDesignation"
  ></lib-cdw-designation-edit>

  <lib-cdw-drawer
    drawerId="designationEditDrawer"
    [toolbarTitle]="drawerTitle"
    [toolbarSubtitle]="drawerSubtitle"
    [drawerWidth]="'350px'"
    [toolbarTitleBackground]="gray50"
    toolbarTitleFontSize="20px"
    toolbarSubtitleFontSize="24px"
    toolbarTitleFontWeight="800"
    toolbarSubtitleFontWeight="800"
    [toolbarTitleColor]="gray300"
    [toolbarSubtitleColor]="tertiaryBlueCta"
    toolbarTitleFontFamily="Source Sans 3"
    toolbarSubtitleFontFamily="Source Sans 3"
  >
    <lib-cdw-drawer-content
      drawerContentId="designationEditSummaryDrawerContent"
      [contentTitle]="drawerTitle"
      [noContentMessage]="'No content'"
      [drawerContents]="drawerContent"
      (editClicked)="onDrawerEditClicked()"
    >
    </lib-cdw-drawer-content>
  </lib-cdw-drawer>
</mat-drawer-container>
